export class ServiceGroup {
  id = null;
  code = null;
  name = null;
  description = null;
  departmentEx = null;
  rooms = null;
  serviceGroupRooms = null;
  parent = null;
  isUsing = true;
}
